import { Base } from '../base-component';
import './accordion-version-two.component.scss';

import * as $ from 'jquery';

export class AccordionVersionTwo extends Base {

	accordionTriggers: Element[];
	collapseTriggers: Element[];
	activeAccordionTrigger: any;
	activeAccordion: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.accordionTriggers = Array.from(this.element.querySelectorAll('.js-accordion-trigger'));
		this.collapseTriggers = Array.from(this.element.querySelectorAll('.js-collapse-trigger'));
	}

	bindEvents() {

		if(this.accordionTriggers) {
			this.accordionTriggers.map((item) => item.addEventListener('click', (event) => {
				this.toggleAccordions(event);
			}));
		}

		if(this.collapseTriggers) {
			this.collapseTriggers.map((item) => item.addEventListener('click', (event) => {
				this.toggleCollapses(event);
			}));
		}

	}
	
	toggleAccordions(event) {
		const _target = <HTMLElement>event.target;
		const _selected = _target.closest('.js-accordion-trigger');
		if (_selected.classList.contains('accordion-version-two__item--open')) {
			this.closeAccordion();
		} else {
			this.closeAccordion();
			this.openAccordion(event);
		}
	}

	toggleCollapses(event) {

		const _target = <HTMLElement>event.target;
		const _parent  = _target.closest('.accordion-version-two--collapse');
		let _container: any = _parent.querySelector('.accordion-version-two--collapse__container');
		let _containerInner: any = _container.querySelector('.accordion-version-two--collapse__container--inner');
		let _varInnerHeight = _containerInner.offsetHeight;

		if(_parent.classList.contains('accordion-version-two--collapse__opened')) {

			_container.style.height = "0px";
			setTimeout(() => {
				_parent.classList.remove('accordion-version-two--collapse__opened');
			}, 300);
			
		} else {

			_container.style.height = _varInnerHeight + "px";
			_parent.classList.add('accordion-version-two--collapse__opened');

		}

	}

	closeAccordion() {

		const _activeAccordionTrigger = Array.from(this.element.querySelectorAll('.accordion-version-two__item--open'));
		const _activeAccordion = Array.from(this.element.querySelectorAll('.accordion-version-two__item-content--open'));

		_activeAccordionTrigger.map((_elem) => {
			_elem.classList.remove('accordion-version-two__item--open');
			_elem.classList.add('accordion-version-two__item--closed');
		});

		_activeAccordion.map((_elemContent) => {
			_elemContent.classList.remove('accordion-version-two__item-content--open');
			_elemContent.classList.add('accordion-version-two__item-content--closed');
		});

	}

	openAccordion(event) {

        this.stopVideos();
		const _target = <HTMLElement>event.target;
		const _selectedParent = _target.closest('.js-accordion-trigger');
		setTimeout(() => {
			const _selected = _selectedParent.parentElement.querySelector('.accordion-version-two__item--closed');
			const _selectedContent = _selectedParent.parentElement.querySelector('.accordion-version-two__item-content--closed');

			_selected.classList.remove('accordion-version-two__item--closed');
			_selected.classList.add('accordion-version-two__item--open');

			_selectedContent.classList.remove('accordion-version-two__item-content--closed');
			_selectedContent.classList.add('accordion-version-two__item-content--open');

			if(document.querySelector('.cookie-policy').classList.contains('cookie-policy--hidden') && document.querySelector('.cookie-policy').classList.contains('cookie-policy--closed')) {

				if(document.querySelector('.header').classList.contains('header--sticky')) {
					$('html,body').animate({ 
						scrollTop: $(_selected).offset().top - 144
					}, 'slow');
				}else{
					$('html,body').animate({ 
						scrollTop: $(_selected).offset().top - 274
					}, 'slow');
				}

			}else{

				if(document.querySelector('.cookie-policy').classList.contains('cookie-policy--open')) {

					if(document.querySelector('.header').classList.contains('header--sticky')) {
						$('html,body').animate({ 
							scrollTop: $(_selected).offset().top - 144
						}, 'slow');
					}else{
						$('html,body').animate({ 
							scrollTop: $(_selected).offset().top - 350
						}, 'slow');
					}

				}else{

					if(document.querySelector('.header').classList.contains('header--sticky')) {
						$('html,body').animate({ 
							scrollTop: $(_selected).offset().top - 65
						}, 'slow');
					}else{
						$('html,body').animate({ 
							scrollTop: $(_selected).offset().top - 195
						}, 'slow');
					}

				}

			}
			
		}, 400);

	}

    stopVideos() {

        let videosVidavee = Array.from(this.element.querySelectorAll('video'));
        let videosYoutube = Array.from(this.element.querySelectorAll('#video__external'));

        videosVidavee.map((video: any)=>{
            if(video.player) {
                video.player.pause();
            }
        });

        videosYoutube.map((video: any)=>{
            //this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
            console.log(video);

    }

}


// WEBPACK FOOTER //
// ./components/accordion-version-two/accordion-version-two.component.ts